import React from 'react'
import PropTypes from 'prop-types';

// Redux
import { connect } from 'react-redux';

import { Avatar } from '@material-ui/core';
import DefaultAvatar from 'react-avatar';

import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import { acceptFollowRequest, denyFollowRequest } from '../../actions/groupActions';
import { useState } from 'react';
import { setAlert } from '../../actions/alertActions';

const FollowRequestBlock = ({
    groupId,
    groupName,
    groupAvatar,
    follow_request,
    setAlert
}) => {

    const [hide, setHide] = useState(false);

    // Handle accepting follow request
    const handleAcceptRequest = async ({ groupId, groupName, groupAvatar, request_obj }) => {
        try {
            setHide(true);
            await acceptFollowRequest({ groupId, groupName, groupAvatar, request_obj });

            setAlert('Accepted Request', 'okay');
        } catch (error) {
            console.log('Accept Request Failed');
            setHide(false);
            setAlert(`Error: ${error.message || 'Something went wrong'}`, 'danger');
        }
    }

    // Handle denying follow request
    const handleDenyRequest = async ({ groupId, request_obj }) => {
        try {
            setHide(true);
            await denyFollowRequest({ groupId, request_obj });
        } catch (error) {
            console.log('Deny Request Failed');
            setHide(false);
            setAlert(`Error: ${error.message || 'Something went wrong'}`, 'danger');
        }
    }

    const handleProfileVisit = async () => {
        console.log('About to Visit Profile..');

        window.location.href = `/user/${follow_request.user._id}`;
    }

    const handleGroupVisit = async () => {
        console.log("About to Visit Group page.."); 

        window.location.href = `/groups/${groupId}`;
    }

    if(hide) return <></>;

    return (
        <div className="userTable__block">
            {/* User Avatar - left */}
            <div className="userTable__avatar" onClick={handleProfileVisit}>

                {follow_request.user.img ? (
                    <Avatar src={follow_request.user.img} />
                ) : (
                    <DefaultAvatar name={follow_request.user && `${follow_request.user.first_name} ${follow_request.user.last_name}`} />
                )}
            </div>

            {/* Display the user's name & username */}
            <div className="userTable__info">
                <h3 className='hover_underline' onClick={handleProfileVisit}>
                    {follow_request.user.first_name}{' '}{follow_request.user.last_name}
                </h3>
                <p>wants to join <span onClick={handleGroupVisit} style={{fontWeight: 'bold', textDecoration: 'none', color: '#000'}} className='hover_underline'>{groupName}</span></p>
            </div>

            {/* Follow Btn */}
            <div style={{height: '100%', display: 'flex', gap: '8px', alignItems: 'center', paddingRight: '10px'}}>
                <div onClick={() => handleAcceptRequest({ groupId, groupName, groupAvatar, request_obj: follow_request })} className='see_more_btn blue icon_18' style={{zIndex: 10}}>
                    
                    Accept

                    <span style={{width: '5px'}}></span>
                    {/* Icon */}
                    <AddIcon />
                </div>
                <div onClick={() => handleDenyRequest({ groupId, request_obj: follow_request })} className='see_more_btn red icon_18' style={{zIndex: 10}}>
                    
                    Deny

                    <span style={{width: '5px'}}></span>
                    {/* Icon */}
                    <CloseIcon />
                </div>
            </div>
        </div>
    )
}

FollowRequestBlock.propTypes = {
    setAlert: PropTypes.func.isRequired
}

const mapStateToProps = state => ({

    // Mapping the states from the Redux store to the below props
});

export default connect(mapStateToProps, { 

    // Connecting actions to the component
    setAlert
})(FollowRequestBlock);